import { useEffect, useState } from 'react';

const EMPTY_SIZE = { width: 0, height: 0 };

/**
 * Tracks the game board content box for %-to-pixel motion mapping.
 * @param {import('react').RefObject<HTMLElement | null>} boardRef
 */
export function useBoardSize(boardRef) {
    const [size, setSize] = useState(EMPTY_SIZE);

    useEffect(() => {
        const board = boardRef.current;
        if (!board) return undefined;

        const update = () => {
            const rect = board.getBoundingClientRect();
            setSize({
                width: rect.width,
                height: rect.height,
            });
        };

        update();

        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', update);
            return () => window.removeEventListener('resize', update);
        }

        const observer = new ResizeObserver(update);
        observer.observe(board);
        return () => observer.disconnect();
    }, [boardRef]);

    return size;
}
